/** Scopes + API audience for Auth0 login and silent token (must stay aligned). */
export const getAuth0ApiAuthorizationParams = () => {
  const audience = import.meta.env.VITE_AUTH_AUDIENCE;
  return {
    scope: 'openid profile email',
    ...(audience ? { audience } : {}),
  };
};
